export default "__VITE_ASSET__KxU_Eghx__"